<template>
	<!-- LSP-17328: rendered on the session page above the media search, with its own vertical space so it
	     never sits flush against the detail fields or the search field. EntityDetailPage mounts this in BOTH
	     layout branches — `mobile-info` and its `!isMobileLayout` sibling each own a copy of the search UI, so
	     a single mount inside one of them left desktop with no Send Reminder at all. Only one branch renders
	     at a time, so this is one live instance. Both mounts gate on `isAuthenticated` like the search beside
	     them: the POST requires auth, so an unauthenticated viewer would only get an error toast.

	     LSP-23268: this is the session page's ONE upload message — a stuck/abandoned upload, a media shortfall
	     and an unverified recording all render this single blue notice instead of up to three stacked ones.
	     The reminder sentence and Send Reminder join it only when a reminder can actually be sent
	     (`canSendReminder`); otherwise the first sentence stands alone.

	     This lives in its own component because the two layout branches had the whole block — markup, copy and
	     both `v-test` selectors — transcribed verbatim. One copy is how the two branches stay identical. -->
	<IncompleteUploadBanner v-if="canSendReminder" :conversation-id="conversationId" tone="info" class="my-3 pr-2">
		{{ UPLOAD_NOTICE }} {{ UPLOAD_REMINDER_PROMPT }}
	</IncompleteUploadBanner>
	<v-alert
		v-else
		type="info"
		variant="tonal"
		density="compact"
		rounded="lg"
		class="my-3 pr-2"
		v-test="'session-incomplete-upload-notice'">
		{{ UPLOAD_NOTICE }}
	</v-alert>
</template>

<script setup lang="ts">
	import IncompleteUploadBanner from "@/components/IncompleteUploadBanner.vue";

	// LSP-23268: verbatim from the ticket, mirrored by the app's UploadReminderBanner.kt.
	const UPLOAD_NOTICE = "All of your photos, videos, and documents have not been fully uploaded to your account.";
	const UPLOAD_REMINDER_PROMPT = "Click here to send a reminder to finish the uploads.";

	defineProps<{
		conversationId: string;
		/** True when an abandoned upload can be reminded by this viewer; renders the reminder sentence and button. */
		canSendReminder: boolean;
	}>();
</script>
